import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";

import { LOCAL_STORAGE_TOKEN } from "../../constans/roles";
import { useStateValue } from "../../stateProvider/stateProvider";
import Back from "../Back/Back";
import { AddEditSelect } from "../Filter/Filter";
import { createEditController, EDIT_INITIAL_FORM } from "./editController";
import "./Edit.css";

const Edit = ({ getData, formaty, categories, setInfoType, setInfo }) => {
  const navigate = useNavigate();
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(EDIT_INITIAL_FORM);
  const editModalRef = useRef();
  const [{ editID, choosenTable }] = useStateValue();

  const controller = useMemo(
    () =>
      createEditController({
        editID,
        choosenTable,
        getData,
        setItem,
        setLoading,
        setFormData,
        setInfoType,
        setInfo,
        modalRef: editModalRef,
      }),
    [editID, choosenTable, getData, setInfoType, setInfo]
  );

  const setFieldValue = (field, value) => {
    setFormData((previous) => ({
      ...previous,
      [field]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await controller.submitForm(formData);
  };

  useEffect(() => {
    if (!localStorage.getItem(LOCAL_STORAGE_TOKEN)) {
      navigate("/login");
      return;
    }

    controller.loadRecord();
  }, [editID, controller, navigate]);

  return (
    <div className="edit-fixed" ref={editModalRef}>
      <div onClick={controller.hideModal} className="back-btn">
        <Back />
      </div>
      <div className="edit-wrap">
        {item && !loading ? (
          <form className="add-form">
            <div className="add-input-div  add-div-small">
              <label className="add-label" htmlFor="campaign">
                Kampania:
              </label>

              <input
                type="text"
                placeholder="Wpisz"
                name="campaign"
                value={formData.Kampania}
                onChange={(event) =>
                  setFieldValue("Kampania", event.target.value)
                }
              />
            </div>
            <div className="add-input-div  add-div-small">
              <label className="add-label" htmlFor="client">
                Klient:
              </label>

              <input
                type="text"
                placeholder="Wpisz"
                name="client"
                value={formData.Klient}
                onChange={(event) => setFieldValue("Klient", event.target.value)}
              />
            </div>
            <AddEditSelect
              val={formData.Format}
              title="Format"
              defaultt={formData.Format}
              opts={formaty}
              set={(value) => setFieldValue("Format", value)}
            />
            <AddEditSelect
              val={formData.Kategoria}
              title="Kategoria"
              defaultt=""
              opts={categories}
              set={(value) => setFieldValue("Kategoria", value)}
            />

            <div className="add-input-div add-div-medium">
              <label className="add-label" htmlFor="link">
                Link:
              </label>

              <input
                placeholder="Wklej"
                type="text"
                name="link"
                value={formData.Link}
                onChange={(event) => setFieldValue("Link", event.target.value)}
              />
            </div>
            <div className="add-button-div">
              <button className="add-submit " type="submit" onClick={handleSubmit}>
                Edytuj
              </button>
            </div>
          </form>
        ) : (
          <div>Loading...</div>
        )}
      </div>{" "}
    </div>
  );
};

export default Edit;
